import {
  Building2,
  Calendar,
  Camera,
  Car,
  ChevronLeft,
  CircleCheck,
  CircleUser,
  CircleX,
  ClipboardList,
  Clock,
  Coffee,
  Copy,
  EllipsisVertical,
  ExternalLink,
  Eye,
  EyeOff,
  FileText,
  Flag,
  Hammer,
  HeartHandshake,
  House,
  Image,
  Lock,
  LogOut,
  Mail,
  MapPin,
  Megaphone,
  Phone,
  RefreshCw,
  Search,
  ServerCrash,
  Settings,
  Shield,
  ShieldCheck,
  Shirt,
  Sparkles,
  Tag,
  Trophy,
  User,
  Users,
  Utensils,
  Wrench,
} from "@lucide/vue";
import type { IconAliases } from "vuetify";

export const icons: Partial<IconAliases> = {
  user: User,
  users: Users,
  clock: Clock,
  copy: Copy,
  calendar: Calendar,
  settings: Settings,
  sync: RefreshCw,
  admin: Shield,
  eyeOff: EyeOff,
  eye: Eye,
  camera: Camera,
  search: Search,
  logout: LogOut,
  link: ExternalLink,
  externLink: ExternalLink,
  file: FileText,
  phone: Phone,
  email: Mail,
  circleUser: CircleUser,
  confirmation: CircleCheck,
  back: ChevronLeft,
  image: Image,
  location: MapPin,
  company: Building2,
  lock: Lock,
  dashboard: House,
  serverCrash: ServerCrash,
  ellipsisVertical: EllipsisVertical,
  denied: CircleX,
  tag: Tag,
  heartHandshake: HeartHandshake,
  trophy: Trophy,
  flag: Flag,
  megaphone: Megaphone,
  clipboardList: ClipboardList,
  wrench: Wrench,
  hammer: Hammer,
  utensils: Utensils,
  coffee: Coffee,
  car: Car,
  shieldCheck: ShieldCheck,
  shirt: Shirt,
  sparkles: Sparkles,
} as unknown as Partial<IconAliases>;
